var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAigradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1000,
    viewBox: "0 0 1440 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter0_f_2570_27761)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 450.191,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#FFEBA9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 632.202,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#FFD2A9"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 990.446,
    cy: 443.16,
    rx: 220.553,
    ry: 258.726,
    fill: "#E760EA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 867.137,
    cy: 443.274,
    rx: 220.553,
    ry: 258.726,
    fill: "#EA6081"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2570_27761",
    x: -210.674,
    y: -255.877,
    width: 1861.99,
    height: 1398.19,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 220.156,
    result: "effect1_foregroundBlur_2570_27761"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAigradient);
export default __webpack_public_path__ + "static/media/Aigradient.79ce7f5d2ca5664c8b2db05a0eae8a40.svg";
export { ForwardRef as ReactComponent };